import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { DatatableClickEvent, DatatableComponent } from '@basis/angular-components';
import { URLSearchParams } from '@angular/http';

import { environment } from '../../environments/environment';
import { Situacoes } from '../entity/enumeraveis';
import { Status } from '../entity/enumeraveis';
import { SimularUsuario } from '../entity/simular-usuario.model';
import { TrilhaDeAuditoria } from '../entity/trilha_de_auditoria.model';

// import * as FileSaver from 'file-saver';

import { BaseComponent } from './base.component';

@Component({ template: '' })
export class BaseListComponent extends BaseComponent implements OnInit {
    filtro: FormGroup;
    cpfLogado: string;
    nomeLogado: string;
    idLogado: number;
    simularUsuarioEntity: SimularUsuario;
    displaySimularUsuario: Boolean = false;
    trilha: TrilhaDeAuditoria;
    idUsuarioDaSimulacao: Number = 0;
    cpfUsuarioDaSimulacao: string;
    simular_usuario = this.formBuilder.group({
        observacaoSimularUsuario: [null, [Validators.required, Validators.maxLength(200)]]
    });
    @ViewChild('listagem') listagem: DatatableComponent;

    baseUrl: string = `${environment.apiEndpoint}`;
    url(route: string, appendController: boolean = true, filter: any = null): string {
        let params: URLSearchParams = new URLSearchParams();
        if (filter != null) Object.keys(filter).map(k => params.set(k, filter[k]));
        return appendController ? `${this.baseUrl}/${this.controllerName}/${route}?${params.toString()}` : `${this.baseUrl}/${route}?${params.toString()}`;
    }

    simularUsuario() {

        this.observableUtilPanelDoc.setBlockedPanel(true);
        const mensagem = this.validaProsseguimentoSimulacao();

        if (!mensagem) {

            this.simularUsuarioEntity = new SimularUsuario(
                this.idLogado,
                this.idUsuarioDaSimulacao,
                this.simular_usuario.get('observacaoSimularUsuario').value,
                true);

            this.service.CriarNovaSimulacao('simularUsuario', this.simularUsuarioEntity).subscribe(sucess => {
                localStorage.setItem('simulacaoEmAndamento', 'true');
                window.location.href = environment.urlPagInicial;
            },
                err => {
                    this.observableUtilPanelDoc.setBlockedPanel(false);
                    this.simular_usuario.get('observacaoSimularUsuario').reset();
                    this.displaySimularUsuario = false;
                    this.showMsg('warn', 'Mensagem de Erro', `Erro: ${err._body}`)
                });

        } else {
            this.observableUtilPanelDoc.setBlockedPanel(false);
            this.simular_usuario.get('observacaoSimularUsuario').reset();
            this.displaySimularUsuario = false;
            this.showMsg('warn', 'Mensagem de Alerta', mensagem);
        }
    }

    validaProsseguimentoSimulacao(): string {

        const observacao = this.simular_usuario.get('observacaoSimularUsuario').value;
        const naoPossuiCaracteres = observacao ? (!observacao.trim()) : false;

        if (!this.simular_usuario.valid || naoPossuiCaracteres) {
            return 'É obrigatório o preenchimento do campo Observação.';
        } else if (!(this.idLogado !== this.idUsuarioDaSimulacao)) {
            return 'Não é possível simular o usuário da sessão';
        }

        return null;
    }

    cancelaSimular() {
        this.simular_usuario.get('observacaoSimularUsuario').reset();
        this.displaySimularUsuario = false;
    }

    init() {
        this.activatedRoute.data.subscribe(data => {
            if (Object.keys(data).length > 0)
                this.filtro.patchValue(data);
        });
        this.activatedRoute.params.subscribe(param => {
            if (Object.keys(param).length > 0)
                this.filtro.patchValue(param);
        });
    };

    ngOnInit() {
        this.activatedRoute.data.subscribe(data => {
            if (Object.keys(data).length > 0)
                this.filtro.patchValue(data);
        });

        this.bObservale.getValue.subscribe(x => {
            if (x != "" && x) {
                var userInfo = x.obj;
                this.cpfLogado = userInfo.cpf;
                this.nomeLogado = userInfo.nome;
                this.idLogado = userInfo.id;
            }
        });

        this.listagem.extraParams = { emptyMessage: 'Nenhum registro encontrado.' };
        this.init();
    }

    onButtonClick(event: DatatableClickEvent) {
        if (!event.selection || event.selection.length === 0) {
            this.showMsg('warn', 'Mensagem de Alerta', 'Antes de executar esta ação selecione um registro na tabela.');
            return;
        }

        const situacao = event.selection.situacao == null ? null : event.selection.situacao.id;
        const status = event.selection.status == null ? null : event.selection.status.id;

        switch (event.button) {
            case 'edit':
                if (situacao == Situacoes.Autorizado) {
                    this.showMsg('warn', 'Mensagem de Alerta', 'Não é possível editar, porque a resolução já foi autorizada.');
                    return;
                } else if ((status == Status.Aprovado || status == Status.Recusado) && (this.filtro.controls['tipo'].value != 1)) {
                    this.showMsg('warn', 'Mensagem de Alerta', `Não é possível editar, porque a permissão já foi ${status == 2 ? 'aprovada' : 'recusada'}.`);
                    return;
                }
                else {
                    this.router.navigate(['./editar', event.selection['id']], { relativeTo: this.activatedRoute });
                }
                break;
            case 'autorizar':
                if (situacao == Situacoes.Autorizado) {
                    this.showMsg('warn', 'Mensagem de Alerta', 'Não é possível autorizar novamente uma resolução que já foi autorizada.');
                    return;
                } else {
                    this.confirmacao.confirm({
                        header: 'Confirmação',
                        message: 'Deseja realmente autorizar este registro?',
                        accept: () => {
                            this.service.Atualizar(this.controllerName, { id: event.selection['id'], id_situacao: Situacoes.Autorizado }, { parcial: "id_situacao" }).subscribe(
                                data => {
                                    this.listagem.refresh(this.filtro);
                                    this.showMsg('success', 'Mensagem de Sucesso', 'Registro autorizado com sucesso.');
                                },
                                err => this.showMsg('danger', 'Mensagem de Erro', `Houve um erro ao autorizar o registro. ${err}`)
                            );
                        }
                    })
                }
                break;
            case 'aprovar':
                if (status == Status.Aprovado || status == Status.Recusado) {
                    this.showMsg('warn', 'Mensagem de Alerta', `Não é possível executar esta ação, porque a permissão já foi ${status == 2 ? 'aprovada' : 'recusada'}.`);
                    return;
                } else {
                    this.confirmacao.confirm({
                        header: 'Confirmação',
                        message: 'Deseja realmente aprovar este registro?',
                        accept: () => {
                            this.observableUtilPanelDoc.setBlockedPanel(true);
                            this.service.Atualizar(this.controllerName, {
                                id: event.selection['id'],
                                lotacao: event.selection['lotacao'],
                                usuario: event.selection['usuario'],
                                perfil: event.selection['perfil'],
                                id_status: Status.Aprovado,
                                id_usuario_aprovador: this.idLogado
                            }, { parcial: 'id_status' }).subscribe(
                                data => {
                                    this.listagem.pDatatableComponent.selectionChange.emit(undefined)
                                    this.listagem.refresh(this.filtro);
                                    this.observableUtilPanelDoc.setBlockedPanel(false);
                                    this.showMsg('success', 'Mensagem de Sucesso', 'Registro aprovado com sucesso.');
                                },
                                err => {
                                    this.listagem.pDatatableComponent.selectionChange.emit(undefined)
                                    this.observableUtilPanelDoc.setBlockedPanel(false);
                                    this.showMsg('danger', 'Mensagem de Erro', `Houve um erro ao aprovar o registro. ${err}`)
                                });
                        }
                    })
                }
                break;
            case 'recusar':
                if (status == Status.Recusado || status == Status.Aprovado) {
                    this.showMsg('warn', 'Mensagem de Alerta', `Não é possível executar esta ação, porque a permissão já foi ${status == 2 ? 'aprovada' : 'recusada'}.`);
                    return;
                } else {
                    this.confirmacao.confirm({
                        header: 'Confirmação',
                        message: 'Deseja realmente recusar este registro?',
                        accept: () => {
                            this.observableUtilPanelDoc.setBlockedPanel(true);
                            this.service.Atualizar(this.controllerName, {
                                id: event.selection['id'],
                                lotacao: event.selection['lotacao'],
                                usuario: event.selection['usuario'],
                                perfil: event.selection['perfil'],
                                id_status: Status.Recusado,
                                id_usuario_aprovador: this.idLogado
                            }, { parcial: 'id_status' }).subscribe(
                                data => {
                                    this.listagem.pDatatableComponent.selectionChange.emit(undefined)
                                    this.listagem.refresh(this.filtro);
                                    this.showMsg('success', 'Mensagem de Sucesso', 'Registro recusado com sucesso.');
                                },
                                err => {
                                    this.listagem.pDatatableComponent.selectionChange.emit(undefined)
                                    this.observableUtilPanelDoc.setBlockedPanel(false);
                                    this.showMsg('danger', 'Mensagem de Erro', `Houve um erro ao recusar o registro. ${err}`)
                                });
                        }
                    })
                }
                break;
            case 'exibir_boleto':
                this.service.Obter(`${this.controllerName}/gerarBoleto`, event.selection['id']).subscribe(
                    data => {
                        let dateInclusao = new Date(event.selection.lancamento.data_inclusao);
                        let nomeArquivo = `boleto-${dateInclusao.getFullYear()}-${event.selection.cpf}.pdf`;
                        // FileSaver.saveAs(this.b64toFile(data,null,"application/pdf"), nomeArquivo) 
                        this.showMsg('success', 'Mensagem de Sucesso', `O arquivo '${nomeArquivo}' foi baixado automaticamente, verifique na pasta de downloads.`);
                    }
                    , err => this.showMsg('danger', 'Mensagem de Erro', `Houve um erro ao baixar o arquivo. ${err}`)
                );
                break;
            case 'exibir_lancamento':
                this.service.Obter(`${this.controllerName}/baixarRemessa`, event.selection['id']).subscribe(
                    data => {
                        let dateInclusao = new Date(event.selection.data_inclusao);
                        let nomeArquivo = `remessa-${dateInclusao.getFullYear()}-${event.selection.id}.zip`;
                        // FileSaver.saveAs(this.b64toFile(data,null,"application/octet-stream"), nomeArquivo) 
                        this.showMsg('success', 'Mensagem de Sucesso', `O arquivo '${nomeArquivo}' foi baixado automaticamente, verifique na pasta de downloads.`);
                    }
                    , err => this.showMsg('danger', 'Mensagem de Erro', `Houve um erro ao baixar o arquivo. ${err}`)
                );
                break;
            case 'ativar_inativar':
                if (situacao != Situacoes.Ativo && situacao != Situacoes.Inativo) {
                    this.showMsg('warn', 'Mensagem de Alerta', 'Não é possível inativar/ativar este registro.');
                    return;
                } else {
                    this.confirmacao.confirm({
                        header: 'Confirmação',
                        message: `Deseja realmente ${situacao == 1 ? "inativar" : "ativar"} este registro?`,
                        accept: () => {
                            this.service.Atualizar(this.controllerName, { id: event.selection['id'], id_situacao: (situacao == 1 ? 2 : 1) }, { parcial: "id_situacao" }).subscribe(
                                data => {
                                    this.listagem.pDatatableComponent.selectionChange.emit(undefined)
                                    this.listagem.extraButtons.first.disabled = true;
                                    this.listagem.extraButtons.last.disabled = true;
                                    this.observableUtilPanelDoc.setBlockedPanel(false);
                                    this.listagem.refresh(this.filtro);
                                    this.showMsg('success', 'Mensagem de Sucesso', `Registro ${situacao == 1 ? "inativado" : "ativado"} com sucesso.`);
                                },
                                err => {
                                    this.listagem.pDatatableComponent.selectionChange.emit(undefined)
                                    this.observableUtilPanelDoc.setBlockedPanel(false);
                                    this.showMsg('danger', 'Mensagem de Erro', `Houve um erro ao excluir o registro. ${err._body}`)
                                });
                        }
                    })
                }
                break;
            case 'abrir_lancamento':
                this.router.navigate(['./boleto', event.selection['id']], { relativeTo: this.activatedRoute });
                break;
            case 'view':
                this.router.navigate(['./visualizar', event.selection['id']], { relativeTo: this.activatedRoute });
                break;
            case 'historico':
                this.router.navigate(['./historico', event.selection['id']], { relativeTo: this.activatedRoute });
                break;
            case 'relatorio':
                this.router.navigate(['./relatorio', event.selection['id']], { relativeTo: this.activatedRoute });
                break;
            case 'delete':
                if (situacao == Situacoes.Autorizado) {
                    this.showMsg('warn', 'Mensagem de Alerta', 'Não é possível excluir, porque a resolução já foi autorizada.');
                    return;
                    // } else if(this.cpfLogado != cpf && this.controllerName == 'usuarioLotacaoPerfil'){
                    //     this.showMsg('warn', 'Mensagem de Alerta', `Não é possível excluir, usuário ${this.nomeLogado} não tem permissão para excluir esta permissão.`); 
                    //     return;
                    // } else if((this.cpfLogado == cpf) && (this.controllerName == 'usuarioLotacaoPerfil') && (status == Status.Aprovado || status == Status.Recusado)){
                    //     this.showMsg('warn', 'Mensagem de Alerta', `Não é possível executar esta ação, porque a permissão já foi ${status == 2 ? 'aprovada' : 'recusada'}.`); 
                    //     return; 
                } else {
                    this.confirmacao.confirm({
                        header: 'Confirmação',
                        message: 'Deseja realmente remover este registro?',
                        accept: () => {
                            this.service.Deletar(this.controllerName, event.selection['id']).subscribe(
                                sucess => {
                                    this.listagem.refresh(this.filtro);
                                    this.showMsg('success', 'Mensagem de Sucesso', 'Registro excluído com sucesso.');
                                },
                                err => this.showMsg('danger', 'Mensagem de Erro', `Houve um erro ao excluir o registro. ${err._body}`)
                            );
                        }
                    })
                }
                break;
            case 'delete_list':

                const ids_registros = [];
                event.selection.forEach(x =>
                    ids_registros.push(parseInt(x.id))
                )
                this.confirmacao.confirm({
                    header: 'Confirmação',
                    message: ids_registros.length > 1 ?
                        'Deseja realmente remover estes registros?' :
                        'Deseja realmente remover este registro?',
                    accept: () => {
                        this.observableUtilPanelDoc.setBlockedPanel(true);
                        this.service.DeletarLista(this.controllerName, ids_registros).subscribe(
                            sucess => {
                                this.listagem.pDatatableComponent.selectionChange.emit(undefined)
                                this.observableUtilPanelDoc.setBlockedPanel(false);
                                this.listagem.refresh(this.filtro);
                                const msg = ids_registros.length > 1 ? 'Registros excluídos com sucesso.' :
                                    'Registro excluído com sucesso.'
                                this.showMsg('success', 'Mensagem de Sucesso', msg);
                            },
                            err => {
                                this.listagem.pDatatableComponent.selectionChange.emit(undefined)
                                this.observableUtilPanelDoc.setBlockedPanel(false);
                                this.showMsg('danger', 'Mensagem de Erro', `Houve um erro ao excluir o registro. ${err._body}`)
                            });
                    }
                })

                break;
            case 'remessa':
                this.showMsg('info', 'Mensagem de Aviso', 'Arquivo de remessa gerado.');
                break;
            case 'processar':
                this.showMsg('info', 'Mensagem de Aviso', 'Arquivo em processamento.');
                break;
            case 'simular_usuario':
                if (situacao === 1) {
                    this.idUsuarioDaSimulacao = event.selection['id'];
                    this.cpfUsuarioDaSimulacao = event.selection['cpf'];
                    this.displaySimularUsuario = true;
                } else {
                    this.showMsg('info', 'Mensagem de Aviso', 'Usuário precisa estar com situação Ativo.');
                }

                break;
            case 'ativar_trilha':
                const trilhaAtivar = new TrilhaDeAuditoria;
                trilhaAtivar.id_status = Status.Aprovado;
                trilhaAtivar.id = event.selection.id;

                this.confirmacao.confirm({
                    header: 'Confirmação',
                    message: 'Deseja realmente aprovar a auditoria?',
                    accept: () => {
                        this.observableUtilPanelDoc.setBlockedPanel(true);
                        this.service.Atualizar(this.controllerName, trilhaAtivar, { parcial: 'status' }).subscribe(
                            sucess => {
                                this.listagem.pDatatableComponent.selectionChange.emit(undefined)
                                this.observableUtilPanelDoc.setBlockedPanel(false);
                                this.listagem.refresh(this.filtro);
                                this.showMsg('success', 'Mensagem de Sucesso', 'Auditoria aprovada com sucesso');
                            },
                            err => {
                                this.listagem.pDatatableComponent.selectionChange.emit(undefined)
                                this.observableUtilPanelDoc.setBlockedPanel(false);
                                this.showMsg('danger', 'Mensagem de Erro', `Houve um erro a aprovar a auditotia. ${err._body}`)
                            });
                    }
                })
                break;
            case 'inativar_trilha':
                const trilhaInativar = new TrilhaDeAuditoria;
                trilhaInativar.id_status = Status.Recusado;
                trilhaInativar.id = event.selection.id;

                this.confirmacao.confirm({
                    header: 'Confirmação',
                    message: 'Deseja realmente recusar a auditoria?',
                    accept: () => {
                        this.observableUtilPanelDoc.setBlockedPanel(true);
                        this.service.Atualizar(this.controllerName, trilhaInativar, { parcial: 'status' }).subscribe(
                            sucess => {
                                this.listagem.pDatatableComponent.selectionChange.emit(undefined)
                                this.observableUtilPanelDoc.setBlockedPanel(false);
                                this.listagem.refresh(this.filtro);
                                this.showMsg('success', 'Mensagem de Sucesso', 'Auditoria inativada com sucesso');
                            },
                            err => {
                                this.listagem.pDatatableComponent.selectionChange.emit(undefined)
                                this.observableUtilPanelDoc.setBlockedPanel(false);
                                this.showMsg('danger', 'Mensagem de Erro', `Houve um erro a inativada a auditotia. ${err._body}`)
                            });
                    }
                })
                break;

            case 'alterar_senha':

                const cpfUsuarioSelecionado = event.selection['cpf']

                if (cpfUsuarioSelecionado !== this.cpfLogado) {
                    this.router.navigate(['/usuarios/alterar-senha/editar', event.selection['id']], { relativeTo: this.activatedRoute });
                } else {
                    this.showMsg('warn', 'Mensagem de Aviso', 'Alteração da Própria senha deve ser feita através do menu.');
                }
                break;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/base/base-list.component.ts